export default __webpack_public_path__ + "static/media/ptov2.64e0ce53.png";